import { createSelector } from 'reselect';

export const selectMovementSpecialists = createSelector(
  state => state.subscription.movementSpecialists.profiles,
  profiles => (profiles ? profiles.toJS() : null)
);

export const selectActiveMovementSpecialist = createSelector(
  [
    state => state.subscription.movementSpecialists.profiles,
    state => state.subscription.movementSpecialists.activeMovementSpecialistId,
  ],
  (profiles, id) => {
    if (profiles.get('loaded') && id) {
      const activeProfile = profiles.getIn(['data', 'results']).find(profile => profile.get('id') === id);

      return activeProfile ? activeProfile.toJS() : null;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/subscription/coaching/movement-specialists/redux/selectors.js